import { render, staticRenderFns } from "./virtualUser.vue?vue&type=template&id=f0abbd20&scoped=true&"
import script from "./virtualUser.vue?vue&type=script&lang=js&"
export * from "./virtualUser.vue?vue&type=script&lang=js&"
import style0 from "./virtualUser.vue?vue&type=style&index=0&id=f0abbd20&prod&scoped=true&lang=css&"
import style1 from "./virtualUser.vue?vue&type=style&index=1&id=f0abbd20&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0abbd20",
  null
  
)

export default component.exports